import { ZoneAssetMapPage } from '~/app/components/zone-asset-map/ZoneAssetMapPage';

export const ZoneAssetMapPageContainer = () => <ZoneAssetMapPage />;
